module.exports = __webpack_public_path__ + "vue/img/suggested-portrait-photo2.b21c184a.jpg";